import { useQuery } from "@tanstack/react-query";
import type { RankOption } from "gsintegrations";
import { religionRepository } from "../repositories/religionRepository";

export const religionRanksQueryKey = (religionId: string) => [
  "religion",
  religionId,
  "ranks",
];

export const useReligionRanksQuery = (religionId: string) => {
  return useQuery<RankOption[]>({
    queryKey: religionRanksQueryKey(religionId),
    queryFn: () => religionRepository.getRanksByReligionId(religionId),
    enabled: !!religionId,
    staleTime: 1000 * 60 * 5,
    gcTime: 60 * 60 * 1000,
    refetchOnMount: "always",
  });
};
